import { ResetPasswordSuccessPage } from "@/features/auth/pages/ResetPasswordSuccess";

const ResetPasswordSuccess = () => {
  return <ResetPasswordSuccessPage />;
};

export default ResetPasswordSuccess;
